
import React, { useEffect, useState, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import moment from "moment";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import logo from "../../../redcliffe_logo.jpeg";
import callIcon from "../../../callicon.png";
import maillIcon from "../../../mailicon.png";
import qcCode from "../../../qrcode.png";
import iso from "../../../iso.png";
import browserIcon from "../../../browsericon.png";
import ReactToPrint from "react-to-print";
import Autocomplete from "@mui/material/Autocomplete";
import { useParams } from "react-router-dom";
import './report.css'
import {
    getAllNewBookings,
    getNbsData,
    getBookingByNbsForm,
} from "../../actions/LimsAdminActions";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none"
        }
    })
);


interface Props {
    getAllNewBookings: any;
    bookingList: any;
    getNbsData: any;
    fetchNbsdata: any;
    getBookingByNbsForm: any;
    bookingnbsform: any;

}
const NbsReport: React.FC<Props> = ({
    getAllNewBookings,
    bookingList,
    getNbsData,
    fetchNbsdata,
    getBookingByNbsForm,
    bookingnbsform,

}) => {
    const [bookingId, setBookingId] = useState<any>("");
    const componentRef = useRef<any>(null);
    const timer = useRef<any>(0);
    const { id } = useParams<{ id: string }>();
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return <button style={{ marginLeft: "10px" }}>Print Receipt</button>;
    }, []);

    useEffect(() => {
        getAllNewBookings(`booking_id=${id}`);
        getNbsData(`type=booking&bid=${id}`);
        getBookingByNbsForm(`${id}`);
    }, [])

    const [reportData, setReportData] = useState<any>([]);

    useEffect(() => {
        const storeData: any = [];
        if (bookingList?.results && bookingList?.results?.length > 0) {
            bookingList?.results?.map((list: any) => {
                storeData.push({
                    ...list,
                })
            })
        }
        setReportData(storeData);
    }, [bookingList])

    const [itdoseData, setidDoseData] = useState<any>([]);

    useEffect(() => {
        const data: any = [];
        if (fetchNbsdata && fetchNbsdata?.length > 0) {
            fetchNbsdata?.map((list: any) => {
                data.push({
                    ...list
                })
            })
        }
        setidDoseData(data);

    }, [fetchNbsdata])
    
    const [nbsData, setnbsData] = useState<any>([])

    useEffect(() => {
        const nbsData: any = [];
        if (bookingnbsform && bookingnbsform?.length > 0) {
            bookingnbsform?.map((list: any) => {
                nbsData.push({
                    ...list
                })
            })
        }
        setnbsData(nbsData);
    }, [bookingnbsform]);

    return (
        <div style={{ margin: "55px auto" }}>
            <div>
                <div style={{ height: "20px", }}>
                    <div>
                        <ReactToPrint
                            content={reactToPrintContent}
                            trigger={reactToPrintTrigger}
                        />
                    </div>
                </div>
            </div>
            <div
                id="PAGE"
                ref={componentRef}
                style={{
                    width: 1122,
                    background: "#fff",

                }}
            >

                {/* header section */}
                <div className="page-header">
                    <div style={{ padding: "20px" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                background: "#fff",

                            }}
                        >
                            <div style={{ width: "80%", padding: 15 }}>
                                <div style={{ color: "black", fontWeight: "bold", fontSize: "30px", textAlign: "left" }}>
                                    LABORATORY REPORT
                                </div>
                            </div>
                            <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                <h3>
                                    <img src={logo} alt="logo" style={{ width: "200px" }} />
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
                {/* header section closed */}

                {/* patient section details */}
                <div style={{ padding: "20" }} className="bodyPage">

                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",

                        }}
                    >
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <div style={{ color: "#b52155", fontWeight: "bold", fontSize: "30px" }}>
                                NEWBORN SCREENING PROFILE
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "30%", marginLeft: 8 }}>Name of Baby:</div>
                        <div style={{ width: "30%", marginLeft: 8 }}>Mothers Name:{reportData[0]?.customer_name}</div>
                        <div style={{ width: "40%", marginLeft: 8 }}>Test/Package:{reportData[0]?.packages[0]?.name}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "30%", marginLeft: 8 }}>Booking No:{nbsData[0]?.booking}</div>
                        <div style={{ width: "30%", marginLeft: 8 }}>Barcode No:</div>
                        <div style={{ width: "40%", marginLeft: 8 }}>Sample Type:</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "30%", marginLeft: 8 }}>Gender:{reportData[0]?.customer_gender}</div>
                        <div style={{ width: "30%", marginLeft: 8 }}>Baby Weight(Kg):{nbsData[0]?.baby_weight}</div>
                        <div style={{ width: "40%", marginLeft: 8 }}>Age(in hrs):{nbsData[0]?.age_in_hours}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "30%", marginLeft: 8 }}>Date Of Birth:</div>
                        <div style={{ width: "30%", marginLeft: 8 }}>Time Of Birth(24 hrs):{nbsData[0]?.birth_time}</div>
                        <div style={{ width: "40%", marginLeft: 8 }}>Report Date & Time:</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "30%", marginLeft: 8 }}>Collection Date & Time:{reportData[0]?.collection_date}</div>
                        <div style={{ width: "30%", marginLeft: 8 }}>Received Date & Time:</div>
                        <div style={{ width: "40%", marginLeft: 8 }}>Specimen Notes:</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "30%", marginLeft: 8 }}>Referred By :</div>
                        <div style={{ width: "30%", marginLeft: 8 }}>Hospital Name:{reportData[0]?.hospital_name}</div>
                        <div style={{ width: "40%", marginLeft: 8 }}>Special Feed: {nbsData[0]?.type_of_feed}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "33%", marginLeft: 8 }}>Blood Transfusion :{nbsData[0]?.blood_transfusion === true ? "Yes" : "No"}</div>
                    </div>

                </div>
                {/* patient details section closed */}

                {/* reslts value */}
                <div style={{ padding: "20" }} className="merginLeft">
                    <div style={{ color: "#fff", marginTop: "30px", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        RESULT
                    </div>
                    <div style={{ width: "100%", textAlign: "left" }}>
                        <TableContainer style={{ borderRadius: "8px", marginTop: "5px" }}>
                            <Table stickyHeader aria-label="simple">
                                <TableHead style={{ backgroundColor: "#b3b3b3" }}>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}
                                        >
                                            Disorder
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}
                                        >
                                            Parameters
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}
                                        >
                                            Results
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}
                                        >
                                            Results Value
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}
                                        >
                                            Reference
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}
                                        >
                                            Remarks
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableCell
                                        align="center"
                                    >
                                        Glucose 6 Phosphate Dehydrogenase deficiency
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        G6PD
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <progress value={itdoseData[0]?.value} max="100" />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        {itdoseData[0]?.value}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        NTL 3 U/dl
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        normal
                                    </TableCell>
                                </TableBody>
                                <TableBody>
                                    <TableCell
                                        align="center"
                                    >
                                        Congential Adrenal Hyperplasia
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        17-OHP
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <progress value={itdoseData[1]?.value} max="10" />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        {itdoseData[1]?.value}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        NMT 10 μu/ml
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        normal
                                    </TableCell>
                                </TableBody>
                                <TableBody>
                                    <TableCell
                                        align="center"
                                    >
                                        Cystic Fibrosis
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        IRT
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <progress value={itdoseData[2]?.value} max="90" />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        {itdoseData[2]?.value}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        NMT 90 ng/mL
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        normal
                                    </TableCell>
                                </TableBody>
                                <TableBody>
                                    <TableCell
                                        align="center"
                                    >
                                        Classical Galactosemia
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        T GAL
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <progress value={itdoseData[3]?.value} max="25" />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        {itdoseData[3]?.value}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        NMT 25 mg/dl
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        normal
                                    </TableCell>
                                </TableBody>
                                <TableBody>
                                    <TableCell
                                        align="center"
                                    >
                                        Congental Hypothyroidism
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        TSH
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <progress value={itdoseData[4]?.value} max="30" />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        {itdoseData[4]?.value}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        NMT 10 μu/ml
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        normal
                                    </TableCell>
                                </TableBody>
                                <TableBody>
                                    <TableCell
                                        align="center"
                                    >
                                        Profound Biotinidase deficiency
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        BTD
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <progress value={itdoseData[5]?.value} max="100" />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        {itdoseData[5]?.value}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        NLT 15 U/dl
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        normal
                                    </TableCell>
                                </TableBody>
                                <TableBody>
                                    <TableCell
                                        align="center"
                                    >
                                        Phenylketonuria (PKU)
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        Phenylalanine
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <progress value={itdoseData[5]?.value} max="90" />
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        {itdoseData[5]?.value}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        NMT 70 ng/mL
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        normal
                                    </TableCell>
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </div>
                </div>
                {/* reslts value closed */}

                <div style={{ padding: "20" }} className="merginLeft">
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",
                            padding: "20px"

                        }}
                    >
                        <div style={{ width: "22%" }}>
                            <h5>
                                Initial Report<input type="checkbox" style={{ marginLeft: "10px", width: "30px", height: "20px" }} />
                            </h5>
                        </div>
                        <div style={{ width: "25%" }}>
                            <h5>
                                Duplicate Report<input type="checkbox" style={{ marginLeft: "10px", width: "30px", height: "20px" }} />
                            </h5>
                        </div>
                        <div style={{ width: "25%", }}>
                            <h5>
                                Revision Report<input type="checkbox" style={{ marginLeft: "10px", width: "30px", height: "20px" }} />
                            </h5>
                        </div>
                        <div style={{ width: "25%" }}>
                            <h5>
                                Version No<input type="checkbox" style={{ marginLeft: "10px", width: "30px", height: "20px" }} />
                            </h5>
                        </div>
                    </div>
                </div>

                <div style={{ padding: "20" }} className="merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        INTERPRETATION
                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }}>
                        <h6>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna </h6>
                    </div>

                </div>

                <div style={{ padding: "20" }} className="merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        METHODOLOGY
                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }}>
                        <h6>FEIA-Flurometric Enzyme Immunoassay</h6>
                    </div>

                </div>

                <div style={{ padding: "20" }} className="merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        RECOMMENDATION
                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }}>
                        <h6>Please correlate the results with other clinnical and daigonostic findings.</h6>
                    </div>
                </div>

                <div style={{ padding: "20" }}>
                    <div style={{ padding: "20px" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                background: "#fff",

                            }}
                        >
                            <div style={{ width: "65%", textAlign: "left", padding: 15 }}>
                                <p>
                                    <input type="text" value="Singnature" style={{ border: "none" }} /><br />
                                </p>
                            </div>
                            <div style={{ width: "35%", padding: 15, textAlign: "left" }}>
                                <input type="text" value="Name" size={10} style={{ border: "none" }} /><br />
                                <input type="text" value="Dr. Sohini Sengupta" style={{ border: "none" }} size={40} /><br />
                                <input type="text" value="MD (CI Biochemistry), DNB,
                            FNB (Lab Medicine)" style={{ border: "none" }} size={50} /><br />
                                <input type="text" value="Medical Laboratory Director" style={{ border: "none" }} size={50} /><br />
                                <input type="text" value="HOD (Biochemistry & Special Assays QR Position)" style={{ border: "none" }} size={50} /><br />
                            </div>
                        </div>
                    </div>

                </div>

                <div style={{ padding: "20", }}>
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>

                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }} className="tablecontent">
                        {/* <h6>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna</h6> */}-
                    </div>
                </div>



                {/* second page  starting */}
                <div style={{ padding: "20" }} className="PageBody">
                    <div style={{ backgroundColor: "#2b0980", width: "100%", textAlign: "center", fontWeight: "bold", color: "white", height: "30px", fontSize: "20px" }}>
                        CONDITIONS OF REPORTING
                    </div>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",
                            padding: "25px"
                        }}
                    >
                        <ul>
                            <li>It is Presumed that specimen belongs to patient named or identified, such verification being carried out at
                                the point of generation of said specimen </li>

                            <li>A test might not be performed due to following reason</li>

                            - Specimen Quantity not sufficient (Inadequate collection/spillage during transit)<br />

                            - Specimen Quality not acceptable (Hemolysis/clotted/lipemic.)<br />

                            - Incorrect sample type<br />

                            - Test cancelled either on request of patient or doctor<br />

                            In any of the above case a fresh specimen will be required for testing and reporting<br />

                            <li> The results of the tests may vary from lab to lab ; time to time for the same patient </li>

                            <li> The reported results are dependent on individual assay methods, equipment, method sensitivity,
                                specificity and quality of the specimen received</li>

                            <li>Partial representation of report is not allowed</li>

                            <li>The reported tests are for the notification of the referring doctor, only to assist him/her in the
                                diagnosis and management of the patient</li>

                            <li>lf Sample collection date is not stated on test requisition form, the current date will be printed by
                                default as the date of collection.</li>

                            <li>Report with status “Preliminary” means one or more test are yet to be reported</li>
                            <li>This report is not valid for Medico Legal Purpose</li>

                            <li>Applicable Jurisdiction will be of “Delhi” for any dispute/claim concerning the test(s) & results of the test (s)</li>
                            <li>Neonatal 17-OH-Progesterone test enables the quantification of 17-OH-Progestrone steroid present in blood. Deficiency of the
                                enzyme 21-hydroxylase is the most frequent cause of Congenital Adrenal Hyperplasia (CAH), and results in high level of circulating 17-OH-Progesterone.
                                Symptoms of CAH range from hypoglycemia, water loss, salt-losing tendency to masculinization in varying combinations,
                                and can be effectively treated by steroid substitution therapy if detected in early stage of life.</li>

                            <li> Neonatal hTSH enables the quantitative determination of human thyrotropin (hTSH) in blood.
                                It is a primary test for screening of babies for Congenital Hypothyroidism (CH), characterized by decreased levels of thyroid hormones: thyroxine (T4) and triiodothyronine (T3).
                                The condition, if undiagnosed and untreated, leads to severe mental retardation, as well as to growth and developmental disturbances. Due to the availability of effective replacement therapy,
                                screening for CH in newborns is recommended to facilitate early intervention where appropriate.</li>

                            <li>Neonatal G6PD test is designed for the quantitative determination of glucose-6-phosphate dehydrogenase activity in blood.
                                G6PD deficiency is the most common human enzyme deficiency, resulting in a condition called Hemolytic Anemia. In some cases,
                                neonatal jaundice occurs, which is severe enough to cause death or permanent neurologic damage. Identification of the deficiency
                                therefore becomes critical for prevention of acute episodes, precipitated by certain oxidative drugs, fava beans, or infections.</li>

                            <li>Neonatal Biotinidase determines human Biotinidase enzyme activity in blood. Profound Biotinidase deficiency can lead to a decrease in biotin
                                availability and if untreated, is associated with neurologic and cutaneous consequences, including development delays, seizures, ataxia, hypotonia,
                                metabolic compromises etc. and may be life threatening. Biotin supplementation can prevent the development of symptoms of biotinidase deficiency, which makes early diagnosis crucial.</li>
                        </ul>
                    </div>
                </div>
                <div style={{ padding: "20" }} className="merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", height: "25px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        Disclaimer
                    </div>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        background: "#fff",
                        padding: "20px"
                    }}>
                        1. The testing laboratory does not bear responsibility for the details provided in the TRF.<br />
                        2. It is presumed that the received specimen belongs to the patient named or identified in the test request form.<br />
                        3. This is a screening test only. Negative screening does not rule out the possibility of underlying metabolic / genetic disorder.<br />
                        4. The metabolites and health condition mapping is not mutually unique and there can be other forms in which an abnormality maybe apparent.<br />
                        5.The health condition may not exclusively be an outcome of the disorder in consideration. If the new bom is premature, retest is suggested when adjust-
                        ed gestational age is 40 weeks.<br />
                        6.  Allinvestigations have their limitations which depend on the sensitivity and specificity of assay procedures as well as the quality of specimen received
                        by the laboratory.<br />
                        7. The baby’s health should be monitored in case of any unhealthy condition with in or beyond the scope of this test.<br />
                        8. This report is not subject to use for any medicolegal purpose.
                    </div>
                </div>

                <div style={{ padding: "20px" }}>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",

                        }}
                    >
                        <div style={{ width: "65%", textAlign: "left", padding: 15 }}>
                            <p>
                                <input type="text" value="Singnature" style={{ border: "none" }} /><br />
                            </p>
                        </div>
                        <div style={{ width: "35%", padding: 15, textAlign: "left" }}>
                            <input type="text" value="Name" size={10} style={{ border: "none" }} /><br />
                            <input type="text" value="Dr. Sohini Sengupta" style={{ border: "none" }} size={40} /><br />
                            <input type="text" value="MD (CI Biochemistry), DNB,
                            FNB (Lab Medicine)" style={{ border: "none" }} size={50} /><br />
                            <input type="text" value="Medical Laboratory Director" style={{ border: "none" }} size={50} /><br />
                            <input type="text" value="HOD (Biochemistry & Special Assays QR Position)" style={{ border: "none" }} size={50} /><br />
                        </div>
                    </div>
                </div>
                {/* footer section starting */}
                <div className="page-footer">

                    {/* footer area */}
                    <div style={{ padding: "20px" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                background: "#fff",
                            }}
                        >
                            <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                <h3>
                                    <img src={qcCode} alt="logo" style={{ width: "180px" }} />
                                </h3>
                            </div>
                            <div style={{ width: "85%", textAlign: "left", padding: 15 }}>
                                <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                                    <div style={{ width: "33%", marginLeft: 8 }}><img src={callIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /> <span style={{ color: "red" }}>898-898-8787</span></div>
                                    <div style={{ width: "33%", marginLeft: 8 }}><img src={maillIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /><span style={{ color: "red" }}>care@redcliffelabs.com</span></div>
                                    <div style={{ width: "33%", marginLeft: 8 }}><img src={browserIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /><span style={{ color: "red" }}>www.redcliffelabs.com</span></div>
                                </div>
                                <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "left" }}>
                                    <h6 style={{ marginLeft: "16px" }}> Redcliffe Lifetech Pvt. Ltd. (Unit of Redcliffe Lifetech inc,USA)Khasra No. 186 First Floor Sonakpur Pargana Kanth Road,
                                        Moradabad U.P 244001</h6>
                                </div>
                                <div style={{ width: "100%", display: "flex", margin: "10px 0px", marginLeft: "16px", textAlign: "left" }}>
                                    <p> All Lab are subjected to clinical interpretations by qualified medical professional and this report is not subject to use for any medico-legal purpose.</p>
                                </div>
                                <hr style={{ backgroundColor: "red", width: "100%", height: "8px" }} />
                            </div>
                        </div>
                        {/* second page  */}

                    </div>
                    {/* footer area closed */}

                </div>
                {/* footer section end */}


            </div>
            {/* last Page */}
        </div>

    )
};

const mapStateToProps = (state: any) => ({
    bookingList: state.LimsAdminReducer.bookingList,
    fetchNbsdata: state.LimsAdminReducer.fetchNbsdata,
    bookingnbsform: state.LimsAdminReducer.bookingnbsform,
});

export default connect(mapStateToProps, {
    getAllNewBookings,
    getNbsData,
    getBookingByNbsForm,
})(NbsReport);
